export const statusMap = [{
    status: 0,
    name: '等待付款',
}, {
    status: 1,
    name: '已关闭',
}, {
    status: 2,
    name: '待发货',
}, {
    status: 3,
    name: '已发货',
}, {
    status: 4,
    name: '交易成功',
}, {
    status: 5,
    name: '已退货',
}
];

export const menus = [
    {
        id: 14,
        name: '仓库待发货列表',
        router: 'Cangku',
        icon: 'dingdanbaobiao-xuanzhong',
    },
    {
        id: 17,
        name: '仓库已发货列表',
        router: 'Fahuo',
        icon: 'dingdanliebiao-xuanzhong1',
    },
];
//员工
export const menus2 = [
    {
        id: 16,
        name: '商城补单',
        router: 'Mendian',
        icon: 'pifashichang-xuanzhong',
    },
    {
        id: 1,
        name: '商城订单',
        router: 'OrderLists',
        icon: 'dingdanliebiao-xuanzhong1',
    },
    {
    id: 15,
    name: '待分配订单',
    router: 'OrderList2',
    icon: 'dingdanliebiao-xuanzhong1',
},
    {
    id: 9,
    name: '安装列表',
    router: 'install_list',
    icon: 'dingdanliebiao-xuanzhong1',
},
    {
    id: 12,
    name: '安装单报表',
    router: 'install_report',
    icon: 'dingdanbaobiao-xuanzhong',
}, {
    id: 13,
    name: '结算单报表',
    router: 'install_jiesuan',
    icon: 'dingdanbaobiao-xuanzhong'
},
    {
        id: 17,
        name: '订单报表',
        router: 'Reports',
        icon: 'dingdanbaobiao-xuanzhong',
    },
    {
        id: 14,
        name: '仓库待发货列表',
        router: 'Cangku',
        icon: 'dingdanbaobiao-xuanzhong',
    },
    {
        id: 17,
        name: '仓库已发货列表',
        router: 'Fahuo',
        icon: 'dingdanliebiao-xuanzhong1',
    },
    {
        id: 8,
        name: '询价单列表',
        router: 'InquiryList',
        icon: 'pifashichang-xuanzhong',
    },
    {
        id: 10,
        name: '公告',
        router: 'Announcement',
        icon: 'mendianguanli-xuanzhong',
    },
];



// WEBPACK FOOTER //
// ./src/utils/config.js